import { StatCard } from "@/components/admin/payouts/primitives";
import type { Company } from "@/types";

function fmtStatMoney(n: number): string {
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function CompaniesStats({
  companies,
  isLoading,
}: {
  companies: Company[];
  isLoading: boolean;
}) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-border/60 bg-card px-4 py-3.5 shadow-sm sm:px-5 sm:py-4"
          >
            <div className="h-3.5 w-20 animate-pulse rounded bg-muted" />
            <div className="mt-2.5 h-7 w-16 animate-pulse rounded bg-muted/60 sm:h-8" />
          </div>
        ))}
      </div>
    );
  }

  const active = companies.filter((c) => c.status === "active").length;
  const suspended = companies.length - active;
  const employees = companies.reduce((sum, c) => sum + c.employeeCount, 0);
  const credit = companies.reduce((sum, c) => sum + (c.creditBalance ?? 0), 0);

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <StatCard label="Aktivne" value={String(active)} tone="primary" />
      <StatCard
        label="Suspendirane"
        value={String(suspended)}
        tone={suspended > 0 ? "amber" : "neutral"}
      />
      <StatCard label="Zaposlenih" value={String(employees)} />
      <StatCard label="Ukupni kredit" value={fmtStatMoney(credit)} suffix="KM" />
    </div>
  );
}
